module.exports = __webpack_public_path__ + "img/img-navegacion-app.5492281f.webp";